import React from 'react';
import { Breadcrumb } from 'antd';
import Link from 'next/link';

type BreadcrumbType = {
  items: {
    path: string;
    name: string;
  }[];
};

const Breadcrumbs = ({ items }: BreadcrumbType) => {
  return (
    <Breadcrumb
      className="breadcrumb"
      separator={<img src="/icons/separator-icon.svg" alt="breadcrumbs" />}
    >
      {items.map((item, index) => (
        <Breadcrumb.Item key={index}>
          <Link href={item.path}>
            <a>
              <div
                dangerouslySetInnerHTML={{
                  __html: item.name,
                }}
              />
            </a>
          </Link>
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
